module.exports = __webpack_public_path__ + "static/img/应急救灾_0.9b5c2fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/应急救灾_0.jpg
// module id = 2uO4
// module chunks = 1